<template>

  <div class="service_form_details">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="4"
        lg="4"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ fileDetail.fileNo }} - {{ fileDetail.nvsFileType }}
            </h1>
            <p class="log_info">
              File created by {{ getCreatedBy() }} on {{ getCreatedAt() }}<br>Last updated on {{ getUpdatedAt() }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-md-right mb-1"
        md="8"
        lg="8"
        cols="12"
      >
        <div class="user_block file_payment_type user__block-margin-adjust">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Payment Status</h6>
            <h5
              class="text-capitalize"
              :class="`text-${resolvePaymentStatusVariant(fileDetail.paymentStatus)}`"
            >
              {{ fileDetail.nvsFileStatus && fileDetail.nvsFileStatus.toLowerCase() === 'book' ? 'Booking Fee' : fileDetail.paymentStatus || '-' }}
            </h5>
          </div>
        <!-- <div class="action_button">
          <b-button
            v-if="canViewThisAction('update', 'ServiceRequest') || canViewThisAction('update-status', 'ServiceRequest')"
            v-b-modal.serviceRequest-all-modal-update-status
            variant="flat-primary"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-50"
              size="16"
            />
          </b-button>
          <b-button
            v-else
            v-b-tooltip.hover.bottom="'You don’t have permission to edit this information.'"
            variant="flat-primary"
            style="opacity: 0.65;"
            aria-readonly=""
          >
            <feather-icon
              icon="EditIcon"
              class="mr-50"
              size="16"
            />
          </b-button>
        </div> -->
        </div>
        <div class="user_block pr_stage_type user__block-margin-adjust">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>File Status</h6>
            <h5
              class="text-capitalize"
              :class="`text-${resolveFileStatusVariant(fileDetail.nvsFileStatus)}`"
            >
              {{ fileDetail.nvsFileStatus ? fileDetail.nvsFileStatus.toLowerCase() : '' }}
            </h5>
          </div>
          <!-- <div class="action_button">
            <b-button
              v-if="canViewThisAction('update', 'ServiceRequest') || canViewThisAction('update-status', 'ServiceRequest')"
              v-b-modal.serviceRequest-all-modal-update-status
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
            </b-button>
            <b-button
              v-else
              v-b-tooltip.hover.bottom="'You don’t have permission to edit this information.'"
              variant="flat-primary"
              style="opacity: 0.65;"
              aria-readonly=""
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
            </b-button>
          </div> -->
        </div>
        <div class="user_block user__block-margin-adjust">
          <div class="user_avatar">
            <img :src="getAgentImage(fileDetail.agents)">
          </div>
          <div class="user_info">
            <h6>Service Agent</h6>
            <h5>{{ getAgentName(fileDetail.agents) }}</h5>
          </div>
          <!-- <div class="action_button">
              <b-button
                v-if="canViewThisAction('update', 'ServiceRequest') || canViewThisAction('update-assignee', 'ServiceRequest')"
                variant="flat-primary"
                @click="setDutyOfficerModal()"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                  size="16"
                />
              </b-button>
              <b-button
                v-else
                v-b-tooltip.hover.bottom="'You don’t have permission to edit this information.'"
                variant="flat-primary"
                style="opacity: 0.65;"
                aria-readonly=""
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                  size="16"
                />
              </b-button>
            </div> -->
        </div>
      </b-col>
    </b-row>
    <!-- Table Container Card -->

    <b-tabs
      v-model="tabIndex"
      pills
      class="dashboard__tabs file_detail"
    >
      <b-alert
        v-if="fileDetail.ledgerSummary && fileDetail.ledgerSummary.reactivationFee"
        variant="danger"
        show
        class="file-alert danger__alert"
      >
        <div class="alert-body has-radius">
          <span>
            <feather-icon
              size="20"
              icon="AlertTriangleIcon"
              class="mr-25"
            /> <div class="alert_text"><strong>Payment Required!</strong> This file is currently in-active due to un-paid of late payment charges. To re-activate this file, customer are required to pay all the late payment charges.</div>
          </span>
        </div>
      </b-alert>
      <b-alert
        v-if="fileDetail && fileDetail.exerciseStatus"
        variant="warning"
        show
        class="file-alert"
      >
        <div class="alert-body has-radius">
          <!-- <span v-if="fileDetail.nvsFileType == 'Funeral Service Package'">
            <feather-icon
              size="20"
              icon="CalendarIcon"
              class="mr-25"
            /> This file has been exercised from {{ fileDetail.exerciseDate ? dateFormat(fileDetail.exerciseDate) : '' }}
          </span>
          <span v-else-if="fileDetail.nvsFileType == 'Urn'">
            <feather-icon
              size="20"
              icon="CalendarIcon"
              class="mr-25"
            /> This file has been exercised on {{ fileDetail.exerciseDate ? dateFormat(fileDetail.exerciseDate) : '' }}
          </span> -->
          <span class="weight-700">
            <feather-icon
              size="20"
              icon="CheckIcon"
              class="mr-25"
            /> This file has been exercised on {{ fileDetail.exerciseDate ? dateFormat(fileDetail.exerciseDate) : '' }}
          </span>
        </div>
      </b-alert>
      <b-alert
        v-if="fileDetail && fileDetail.transferRequest && ['Pending NP', 'Awaiting Approval'].includes(fileDetail.transferRequest.currentStatus)"
        variant="info"
        show
        class="file-alert info__alert"
      >
        <div class="alert-body has-radius">
          <span class="weight-700">
            <feather-icon
              size="20"
              icon="RepeatIcon"
              class="mr-25"
            /> A {{ fileDetail.transferRequest.transferType == 'ownership' ? 'transfer of ownership request' : 'change of purchaser request' }} for this file is currently {{ fileDetail.transferRequest.currentStatus }}.
          </span>
        </div>
      </b-alert>
      <b-tab
        key="details"
      >
        <template #title>
          <b-card
            no-body
            class="dashboard__tab-card"
          >
            <b-card-body
              class="d-flex align-items-center"
            >
              <b-avatar
                variant="light-primary"
                size="40"
                rounded
              >
                <feather-icon
                  size="20"
                  icon="ListIcon"
                  class="mr-0"
                />
              </b-avatar>
              <div class="truncate ml-2">
                <h2>File Details</h2>
              </div>
            </b-card-body>
          </b-card>
        </template>
        <FileInfo
          :file-info="fileDetail"
          @emitRemarksEdit="fileRemarksEdit"
          @emitTransferDateEdit="fileTransferDateEdit"
          @emitAllowTransfer="allowFileTransfer"
          @emitAllowExercisedTransfer="allowExercisedFileTransfer"
          @emitIntendedUserEdit="intendedUserEdit"
          @emitIntendedUserRemove="intendedUserRemove"
          @emitAllowedExercising="allowedExercising"
          @emitDisallowedExercising="disallowedExercising"
          @emitExercisedForAdd="openExercisedForAddModal"
          @emitExercisedForEdit="openExercisedForEditModal"
          @emitExercisedForRemove="showExercisedForRemoveWarning"
        />
      </b-tab>
      <b-tab
        key="payment"
        lazy
      >
        <template #title>
          <b-card
            no-body
            class="dashboard__tab-card"
          >
            <b-card-body
              class="d-flex align-items-center"
            >
              <b-avatar
                variant="light-primary"
                size="40"
                rounded
              >
                <feather-icon
                  size="20"
                  icon="CreditCardIcon"
                  class="mr-0"
                />
              </b-avatar>
              <div class="truncate ml-2">
                <h2>Payment Information</h2>
              </div>
              <b-button
                v-if="canViewThisAction('register-payment', 'File')"
                v-b-tooltip.hover
                variant="flat-primary"
                class="ml-auto"
                title="Register Payment"
                :to="{ name: 'customers-register-payment', query: { fileID: fileDetail.fileID } }"
              >
                <feather-icon
                  size="20"
                  icon="DollarSignIcon"
                />
              </b-button>
            </b-card-body>
          </b-card>
        </template>
        <b-card class="dashboard__tab-content-card payment-summary">
          <b-card
            title="Payment Summary"
            class="padding-20"
          >
            <b-row>
              <b-col
                md="7"
                lg="7"
                sm="6"
                class="overview__option-block"
              >
                <div class="overview__option-result-budget-amount card-statistics statistics-body">
                  <b-row>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/page_blue.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.totalDN) ? `$${numberFormat(fileDetail.ledgerSummary.totalDN)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Total Debit Notes
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/dollar_blue.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.totalBilling) ? `$${numberFormat(fileDetail.ledgerSummary.totalBilling)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Total Billings
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/page_green.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.totalCN) ? `$${numberFormat(fileDetail.ledgerSummary.totalCN)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Total Credit Notes
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/budget_icon.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.totalPayment) ? `$${numberFormat(fileDetail.ledgerSummary.totalPayment)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Total Payment
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/dollar_red.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.osExclReactivation) ? `$${numberFormat(fileDetail.ledgerSummary.osExclReactivation)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Outstanding Less Re. Fees
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/dollar_red.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.reactivationFee) ? `$${numberFormat(fileDetail.ledgerSummary.reactivationFee)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Reactivation Fees
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/dollar_yellow.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.outstanding) ? `$${numberFormat(fileDetail.ledgerSummary.outstanding)}` : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Total Outstanding
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                    <b-col md="6">
                      <b-media
                        no-body
                        class="m-25"
                      >
                        <b-media-aside
                          class="mr-1"
                        >
                          <b-img
                            width="48"
                            height="48"
                            :src="require('@/assets/images/admin/clock_yellow.png')"
                            rounded="circle"
                            alt="Circle image"
                          />
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <h4 class="weight-500 h4-color mb-0">
                            {{ fileDetail.installmentSummary ? fileDetail.installmentSummary.remainingTenure : '-' }}
                          </h4>
                          <b-card-text class="text-muted-o mb-0">
                            Remaining Tenure
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col
                md="5"
                lg="5"
                sm="6"
                class="pl-3"
              >
                <b-table-simple
                  borderless
                  responsive
                  class="particulars_of_deceased d-none d-md-block "
                >
                  <b-tbody>
                    <b-tr>
                      <b-th width="230px">
                        Payment Method
                      </b-th>
                      <b-td>{{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.paymentMethod) ? fileDetail.ledgerSummary.paymentMethod : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Purchase Date
                      </b-th>
                      <b-td>{{ fileDetail.confirmDate ? dateFormat(fileDetail.confirmDate) : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Purchase Price
                      </b-th>
                      <b-td>{{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.totalBilling) ? `$${numberFormat(fileDetail.ledgerSummary.totalBilling)}` : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        GST
                      </b-th>
                      <b-td>{{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.totalGST) ? `$${numberFormat(fileDetail.ledgerSummary.totalGST)}` : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Discounts
                      </b-th>
                      <b-td>{{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.discount) ? `$${numberFormat(fileDetail.ledgerSummary.discount)}` : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        GST Rebate
                      </b-th>
                      <b-td>{{ (fileDetail.ledgerSummary && fileDetail.ledgerSummary.gstRebate) ? `$${numberFormat(fileDetail.ledgerSummary.gstRebate)}` : '-' }}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            title=""
            class="padding-20"
          >
            <b-card-title class="d-flex">
              <span>Related Ledger Data</span>
              <b-button
                v-if="canViewThisAction('register-payment', 'File')"
                variant="link"
                class="ml-auto"
                :to="{ name: 'customers-register-payment', query: { fileID: fileDetail.fileID } }"
              >
                Register Payment
              </b-button>
            </b-card-title>
            <b-card-text>
              <b-tabs
                v-model="tabIndexCredit"
                class="purchaser-tabs"
                content-class="mt-2"
              >
                <b-tab
                  title="Billings & Debit Notes"
                >
                  <BillingList
                    :invoices="invoices"
                    :ledger-summary="fileDetail.ledgerSummary"
                  />
                </b-tab>
                <b-tab
                  lazy
                  title="Receipt & Credit Notes"
                >
                  <ReceiptList
                    :receipt-data="receipts"
                    :ledger-summary="fileDetail.ledgerSummary"
                  />
                </b-tab>
                <b-tab
                  lazy
                  title="Allocation"
                >
                  <AllocationList
                    :debit-allocation="fileDetail.debitAllocations"
                    :credit-allocation="fileDetail.creditAllocations"
                  />
                </b-tab>
              </b-tabs>
            </b-card-text>
          </b-card>
          <b-card
            v-if="fileDetail.hasInstallment"
            class="padding-20"
          >
            <b-card-title class="mb-0">
              Installment Schedule
            </b-card-title>
            <b-card-text>
              <InstallmentSchedule
                :open-installment="fileDetail.openInstallment"
                :installment-summary="fileDetail.installmentSummary"
                :ledger-summary="fileDetail.ledgerSummary"
                :past-installments="fileDetail.pastInstallments"
                :installment-data="fileDetail.installmentSchedule"
              />
            </b-card-text>
          </b-card>
        </b-card>
      </b-tab>
      <template #tabs-end>
        <div class="text-right ml-auto vendor-detail-more-icon file_detail_tab_end">
          <b-dropdown
            variant="flat-primary"
            no-caret
            class="px-1"
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('register-payment', 'File')"
              :to="{ name: 'customers-register-payment', query: { fileID: fileDetail.fileID } }"
            >
              <feather-icon icon="DollarSignIcon" />
              <span class="align-middle ml-50">Register Payment</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('send-email-statement', 'File')"
              @click="openEmailStatementModal"
            >
              <feather-icon icon="MailIcon" />
              <span class="align-middle ml-50">Email Statement of Account to Customer</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-tabs>

    <b-card
      header-tag="header"
      class="file_details"
    >
      <div class="d-flex justify-content-between align-items-center w-100 header_part">
        <h5 class="align-middle mr-auto">
          Entitlements
        </h5>
      </div>
      <RelatedEntitlements
        :entitlements="entitlements"
        @emitCountEntitlement="fetchFileDetail"
      />
    </b-card>

    <b-card
      title="Attachments"
      class="mb-3 mt-3 p-2"
    >
      <input
        ref="hiddenAllocationFileInput"
        type="file"
        multiple
        capture
        accept="image/jpeg, image/png, application/pdf"
        class="d-none"
        @change="setAttachment"
      >
      <b-row v-if="fileAttachments.length">
        <!-- Content Left -->
        <b-col
          v-for="(file, key) in fileAttachments"
          :key="key"
          class="content-header-left mb-2"
          cols="12"
          md="4"
        >
          <div
            class="attachment-item"
          >
            <b-img
              v-if="file.type.includes('image')"
              left
              height="40"
              :src="require('@/assets/images/admin/doc_jpg.png')"
              alt="Left image"
            />
            <b-img
              v-if="file.type.includes('application')"
              left
              height="40"
              :src="require('@/assets/images/admin/doc_file.png')"
              alt="Left image"
            />
            <strong>
              <b-link
                v-if="file.fileStorage"
                :to="{ name: 'file-view', params: { id: file.fileStorage } }"
                target="_blank"
              >
                {{ file ? file.name : '' }}
              </b-link>
              <b-link
                v-else-if="file.data"
                :href="file ? file.data : ''"
                target="_blank"
              >
                {{ file ? file.name : '' }}
              </b-link>
            </strong>
            <span>{{ file ? `${file.size}mb` : '' }}</span>
            <span class="remove__doc">
              <b-button
                v-if="canViewThisAction('update', 'File')"
                variant="flat-primary"
                @click="removeAttachment(file.name, file._id)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                  size="18"
                />
              </b-button>
            </span>
          </div>
          <div class="doc__desc new_design">
            <span v-if="file.description">
              {{ file.description }}
            </span>
            <span v-else>
              <button
                v-if="canViewThisAction('update', 'File')"
                @click="updateDescription(key)"
              >
                Add a description
              </button>
            </span>
            <span
              v-if="file.description"
              class="edit__desc"
            >
              <b-button
                v-if="canViewThisAction('update', 'File')"
                variant="flat-primary"
                @click="updateDescription(key)"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                  size="18"
                />
              </b-button>
            </span>
          </div>
        </b-col>
        <b-col
          class="content-header-left mb-2"
          cols="12"
          md="4"
        >
          <b-button
            v-if="canViewThisAction('update', 'File')"
            variant="link"
            class="mr-1 md-mb-1"
            @click="$refs.hiddenAllocationFileInput.click()"
          >
            <feather-icon
              icon="UploadIcon"
              size="20"
              class="mr-50"
            />
            <span
              class="align-middle"
              style="font-weight: 500; font-size: 14px;"
            >
              Upload
            </span>
          </b-button>
          <b-button
            v-if="attachments.length"
            variant="success"
            class="mr-1 md-mb-1"
            @click="uploadFile"
          >
            Save File
          </b-button>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <div class="empty_block">
            <h4>Nothing in here yet</h4>
            <b-button
              v-if="canViewThisAction('update', 'File')"
              variant="link"
              class=""
              @click="$refs.hiddenAllocationFileInput.click()"
            >
              <feather-icon
                icon="UploadIcon"
                size="20"
                class="mr-50"
              />
              <span
                class="align-middle"
                style="font-weight: 500; font-size: 14px;"
              >
                Upload
              </span>
            </b-button>
            <b-button
              v-if="attachments.length"
              variant="success"
              class="mr-1 md-mb-1"
              @click="uploadFile"
            >
              Save File
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      title="Related to this File"
      class="mb-3 mt-3 p-2"
    >
      <b-card-text>
        <b-tabs
          class="purchaser-tabs"
          content-class="mt-2"
        >
          <b-tab
            v-if="canViewThisAction('read', 'File')"
            title="Files"
          >
            <RelatedFilesList :related-files="fileDetail.relatedFiles" />
          </b-tab>
          <b-tab
            v-if="canViewThisAction('read', 'ServiceRequest')"
            lazy
            title="Service Requests"
          >
            <RelatedServiceRequests :service-requests="[]" />
          </b-tab>
          <b-tab
            v-if="canViewThisAction('read', 'InventoryRequest')"
            lazy
            title="Inventory Requests"
          >
            <RelatedInventoryRequests :inventory-requests="[]" />
          </b-tab>
          <b-tab
            v-if="canViewThisAction('read', 'Invoice')"
            lazy
            title="Invoices"
          >
            <RelatedInvoices
              :related-invoices="invoices"
              :file-type="fileDetail.nvsFileType"
            />
          </b-tab>
        </b-tabs>
      </b-card-text>
    </b-card>

    <b-card
      class="mb-3 mt-3 p-2"
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left pb-2"
          cols="12"
          md="12"
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in fileDetailActivityLogs"
          :key="key"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
          <b-button
            v-if="opt.activityDetails && opt.activityDetails.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.activityDetails && opt.activityDetails.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activitykey) in opt.activityDetails"
                  :key="activitykey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <b-modal
      id="modal-attachment-description"
      size="lg"
      title="Attachment Description"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      @ok="saveDescription"
      @cancel="closeDescriptionModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="description"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!description || attachmentKey === ''"
          @click="ok()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-file-remarks"
      size="sm"
      title="Edit Remarks"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      footer-class="iu-edit-modal-footer"
      @ok="saveFileRemarks"
      @cancel="closeFileRemarksModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="fileRemarks"
            rows="6"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!fileRemarks"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-file-transfer-date"
      size="sm"
      title="Edit Date"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      footer-class="iu-edit-modal-footer"
      @ok="saveFileTransferDate"
      @cancel="closeFileTransferDateModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Transfer Date"
            label-for="h-transferDate"
            class="mb-20"
          >
            <b-input-group>
              <flat-pickr
                id="h-transferDate"
                v-model="fileTransferDate"
                class="form-control flat-pickr-group"
                placeholder="Transfer date"
                :config="flatPickrConfig"
              />
              <b-input-group-append is-text>
                <feather-icon
                  icon="CalendarIcon"
                  class="cursor-pointer"
                  data-toggle
                  size="18"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!fileTransferDate"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-file-transfer-date-override"
      size="sm"
      title="Allow Transfer Override"
      modal-class="status-update-modal"
      centered
      no-stacking
      body-class="pt-0"
      header-class="front-modal"
      footer-class="iu-edit-modal-footer"
      @ok="saveOverrideFileTransferDate"
      @cancel="closeTransferOverrideDateModal"
    >
      <b-row>
        <b-col
          md="12"
          class="mb-2"
        >
          <span>
            By setting a date here, you are allowing this file to be <strong>transferable only until this date (inclusive)</strong>, no matter its payment status.
          </span>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Allow transfers to be initiated until"
            label-for="h-transferableUntil"
            :class="transferableUntil ? 'mb-0' : 'mb-1'"
          >
            <b-input-group>
              <flat-pickr
                id="h-transferableUntil"
                v-model="transferableUntil"
                class="form-control flat-pickr-group"
                placeholder="Transferable Until"
                :config="flatPickrConfig"
              />
              <b-input-group-append is-text>
                <feather-icon
                  icon="CalendarIcon"
                  class="cursor-pointer"
                  data-toggle
                  size="18"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button
            v-if="transferableUntil"
            variant="link"
            class="p-0 mt-25 mb-1"
            @click="transferableUntil = ''"
          >
            <feather-icon
              icon="XIcon"
            />
            Remove date
          </b-button>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-exercised-file-transfer-override"
      size="sm"
      title="Allow Transfer When Exercised"
      modal-class="status-update-modal"
      centered
      no-stacking
      body-class="pt-0"
      header-class="front-modal"
      footer-class="iu-edit-modal-footer"
      @ok="saveOverrideExercisedFileTransfer"
      @cancel="closeExercisedFileTransferOverrideModal"
    >
      <b-row>
        <b-col
          md="12"
          class="mb-2"
        >
          <span>
            For all products, files are not transferable once it is exercised. <strong>You can override to allow this, except for FSP files.</strong>
          </span>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Allow transfers even when file is exercised?"
            label-class="weight-500"
          >
            <b-form-radio-group
              v-model="exercisedTransferable"
              :options="exercisedTransferableOptions"
              name="exercisedTransferable"
              stacked
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-update-intended-user"
      ref="update_intended_user_modal"
      modal-class="status-update-modal iu-modal"
      footer-class="iu-edit-modal-footer"
      cancel-variant="flat-primary"
      ok-variant="primary"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      :title="editModalTitle"
      size="sm"
      @ok="intendedUserSubmitForm"
    >
      <b-form @submit.prevent="intendedUserSubmitForm">
        <validation-observer
          ref="intendedUserEditForm"
        >
          <b-form-group
            label="Name*"
            label-for="h-iu-iuName"
            description="These fields can be updated in the entity’s record."
          >
            <b-form-input
              id="h-iu-iuName"
              v-model="iuName"
              placeholder="Name"
              name="iuName"
              disabled
              class="text-uppercase"
            />
          </b-form-group>
          <b-form-group
            label="NRIC*"
            label-for="h-iu-iuNRIC"
          >
            <b-form-input
              id="h-iu-iuNRIC"
              v-model="iuNRIC"
              placeholder="NRIC"
              name="iuNRIC"
              class="text-uppercase"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="Date of Birth*"
            label-for="h-iu-iuDOB"
          >
            <b-form-input
              id="h-iu-iuDOB"
              v-model="iuDOB"
              placeholder="Date of Birth"
              name="iuDOB"
              disabled
            />
          </b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Relationship"
            vid="iuRelationship"
            rules="required"
          >
            <b-form-group
              label="Relationship*"
              label-for="h-iu-iuRelationship"
              :state="(errors.length > 0) ? false : null"
            >
              <v-select
                id="h-iu-iuRelationship"
                v-model="iuRelationship"
                :options="relationshipOptions"
                :clearable="false"
                placeholder="Select an option"
                class="text-uppercase"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Mobile No.*"
            label-for="h-iu-iuContact"
            rules="required"
          >
            <validation-provider
              name="Mobile No."
              rules="required"
            >
              <!-- <cleave
                id="h-iu-iuContact"
                v-model="iuContact"
                class="form-control"
                :raw="false"
                :options="options.prefix"
                @input="iuContactValidation = false"
              /> -->
              <b-form-input
                id="h-iu-iuContact"
                v-model="iuContact"
                placeholder="+65 Enter 8-digits number"
                name="iuContact"
                @input="iuContactValidation = false"
              />
              <small
                v-if="iuContactValidation"
                class="text-danger display-block"
              >
                {{ iuContactError }}
              </small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Residential Address*"
            label-for="h-iu-iuAdd1"
          >
            <validation-provider
              #default="{ errors }"
              name="Address Line 1"
              rules="required"
            >
              <b-form-input
                id="h-iu-iuAdd1"
                v-model="iuAdd1"
                placeholder="Address Line 1"
                name="iuAdd1"
                rules="required"
                class="text-uppercase"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label-for="h-iu-iuAdd2"
          >
            <validation-provider
              #default="{ errors }"
              name="Address Line 2"
              rules="required"
            >
              <b-form-input
                id="h-iu-iuAdd2"
                v-model="iuAdd2"
                placeholder="Address Line 2"
                name="iuAdd2"
                rules="required"
                class="text-uppercase"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Select a country"
            rules="required"
          >
            <b-form-group
              label-for="h-iu-iuCountry"
              :state="(errors.length > 0) ? false : null"
            >
              <v-select
                id="h-iu-iuCountry"
                v-model="iuCountry"
                rules="required"
                :options="countryOptions"
                :clearable="false"
                class="text-uppercase"
                placeholder="Select a country"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label-for="h-iu-iuPostCode"
          >
            <validation-provider
              #default="{ errors }"
              name="Post Code"
              rules="required"
            >
              <b-form-input
                id="h-iu-iuPostCode"
                v-model="iuPostCode"
                placeholder="Post Code"
                name="iuPostCode"
                rules="required"
                class="text-uppercase"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="email-statement-modal-detail-page"
      ref="email-statement-modal-detail-page"
      modal-class="status-update-modal sign-modal-adjust sign-form_modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Email Statement of Account to Customer"
      @ok="sendEmailStatement"
      @cancel="closeStatementModal"
    >
      <div class="">
        <b-form-group
          label="Customer Name"
          label-for="customer-name"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Customer Name"
            vid="customer-name"
            rules=""
          >
            <b-form-input
              id="customer-name"
              v-model="customerNameVal"
              placeholder="Lin Chai"
              class="mb-0 text-uppercase"
              readonly
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Email Address"
          label-for="customer-email"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Email Address"
            vid="customer-email"
            rules="required"
          >
            <b-form-input
              id="customer-email"
              v-model="customerEmailVal"
              placeholder="email@domain.com"
              class="mb-0"
              :readonly="hasEmailAddress ? true : false"
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Message"
          label-for="statement-message"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Message"
            vid="statement-message"
            rules="required"
          >
            <b-form-textarea
              id="statement-message"
              v-model="statementMessage"
              placeholder="Statement of Account"
              class="mb-0"
              rows="9"
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="success"
          class="custom-icon"
          :disabled="!customerEmailVal"
          @click="ok()"
        >
          <feather-icon
            icon="SendIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Send</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-exercised-user"
      ref="exercised_for_modal"
      modal-class="status-update-modal iu-modal"
      cancel-variant="flat-primary"
      ok-variant="primary"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      :title="exercisedModalTitle"
      size="lg"
      @ok="exercisedForSubmitForm"
    >
      <b-form @submit.prevent="exercisedForSubmitForm">
        <validation-observer
          ref="exercisedForm"
        >
          <template v-if="exercisedModalTitle == 'Add Exercised For Person'">
            <validation-provider
              #default="{ errors }"
              name="Pre-fill from Intended User(s)"
              vid="intendedUser"
              rules=""
            >
              <b-form-group
                label="Pre-fill from Intended User(s)"
                label-for="h-iu-intendedUser"
                :state="(errors.length > 0) ? false : null"
              >
                <v-select
                  id="h-iu-intendedUser"
                  v-model="intendedUser"
                  :options="fileDetail.intendedUsers"
                  :clearable="true"
                  label="name"
                  :reduce="op => op.entityID"
                  placeholder="Select from list"
                  class="text-uppercase"
                  :disabled="isIntendedDisabled"
                  @input="getIntendedUserData"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <hr class="mx-n215">
          </template>
          <b-tabs class="exercised-for-tab">
            <b-tab
              title="Basic Fields"
              active
            >
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Exercise date*"
                    label-for="h-exerciseDate"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Exercise date"
                      vid="exerciseDate"
                      rules="required"
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-exerciseDate"
                          v-model="exerciseDate"
                          class="form-control flat-pickr-group"
                          placeholder="Exercise date"
                          :config="flatPickrConfig"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="NRIC*"
                    label-for="h-exercisedNric"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="NRIC"
                      vid="h-exercisedNric"
                      rules="required"
                    >
                      <!-- <b-form-input
                        id="h-exercisedNric"
                        v-model="exercisedNric"
                        placeholder="NRIC"
                        class="text-uppercase"
                        :disabled="isFieldsDisabled"
                        :state="(errors.length > 0) ? false : null"
                      /> -->
                      <b-input-group>
                        <b-form-input
                          id="h-exercisedNric"
                          v-model="nricQuery"
                          name="name"
                          placeholder="Search NRIC"
                          autocomplete="off"
                          tabindex="0"
                          :class="!showCustomerCrossIcon ? 'input__append-border-right' : ''"
                          :disabled="showCustomerCrossIcon || exerciseEditMode"
                          style="margin-bottom: 0;"
                          @keyup="fetchResults()"
                          @focusout="resetCustomerSearchResult"
                        />
                        <b-input-group-append
                          v-if="showCustomerCrossIcon"
                          is-text
                        >
                          <feather-icon
                            icon="XIcon"
                            class="cursor-pointer text-primary"
                            size="18"
                            data-toggle
                            @click="clearCustomerSearchInput"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <div
                        v-show="showCustomerSearchResult"
                        class="search-results mt-50 z-index-99"
                      >
                        <div v-if="foundCustomers.length">
                          <b-list-group flush>
                            <b-list-group-item>
                              <h3 class="mb-0 result-search-header">
                                Customers found
                              </h3>
                            </b-list-group-item>
                            <b-list-group-item
                              v-for="(customer, cIndex) in foundCustomers"
                              :key="cIndex"
                              class="cursor-pointer"
                              @click="setCustomer(customer)"
                            >
                              <h6 class="mb-0 fs-14 text-primary">
                                {{ customer.name }}
                              </h6>
                              <p class="mb-0 fs-12">
                                {{ customer.perContact }} / {{ customer.encryptedNric }} {{ customer.perEmail ? `/ ${customer.perEmail}` : '' }}
                              </p>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                      </div>
                      <div
                        v-show="searchCustomerResultNotFound"
                        class="search-results mt-50 z-index-99"
                      >
                        <b-list-group>
                          <b-list-group-item>
                            <h3 class="mb-0 result-search-header z-index-99">
                              No result found.
                            </h3>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Relationship to Purchaser"
                    vid="exercisedRelationship"
                    rules="required"
                  >
                    <b-form-group
                      label="Relationship to Purchaser*"
                      label-for="h-exercisedRelationship"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedRelationship"
                        v-model="exercisedRelationship"
                        :options="relationshipOptions"
                        :clearable="false"
                        :disabled="(exerciseEditMode && Boolean(intendedUser)) || (isFieldsDisabled && !isIntendedDisabled)"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Name*"
                    label-for="h-exercisedName"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Name"
                      vid="h-exercisedName"
                      rules="required"
                    >
                      <b-form-input
                        id="h-exercisedName"
                        v-model="exercisedName"
                        placeholder="Name"
                        class="text-uppercase"
                        :disabled="exerciseEditMode || isFieldsDisabled"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Chinese Name"
                    label-for="h-exercisedChineseName"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Chinese Name"
                      vid="h-exercisedChineseName"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedChineseName"
                        v-model="exercisedChineseName"
                        placeholder="Chinese Name"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Date of Birth"
                    label-for="h-exercisedDob"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Date of Birth"
                      vid="exercisedDob"
                      rules=""
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-exercisedDob"
                          v-model="exercisedDob"
                          class="form-control flat-pickr-group"
                          placeholder="Date of Birth"
                          :config="flatPickrConfig"
                          :disabled="isFieldsDisabled || exerciseEditMode"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Chinese Date of Birth"
                    label-for="h-exercisedChineseDob"
                    class="mb-20"
                  >
                    <div class="d-flex align-items-center gap-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Year of Birth"
                        vid="h-exercisedChineseDobYear"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="年"
                        >
                          <b-form-input
                            id="h-exercisedChineseDobYear"
                            v-model="exercisedChineseDobYear"
                            type="text"
                            placeholder="Year"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Month of Birth"
                        vid="h-exercisedChineseDobMonth"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="月"
                        >
                          <b-form-input
                            id="h-exercisedChineseDobMonth"
                            v-model="exercisedChineseDobMonth"
                            type="text"
                            placeholder="Month"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Day of Birth"
                        vid="h-exercisedChineseDobDay"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="日"
                        >
                          <b-form-input
                            id="h-exercisedChineseDobDay"
                            v-model="exercisedChineseDobDay"
                            type="text"
                            placeholder="Day"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Death Date"
                    label-for="h-exercisedDod"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Death Date"
                      vid="exercisedDod"
                      rules=""
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-exercisedDod"
                          v-model="exercisedDod"
                          class="form-control flat-pickr-group"
                          placeholder="Death Date"
                          :config="flatPickrConfig"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group
                    label="Chinese Death Date"
                    label-for="h-exercisedChineseDod"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Chinese Death Date"
                      vid="h-exercisedChineseDod"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedChineseDod"
                        v-model="exercisedChineseDod"
                        placeholder="Chinese Death Date"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col> -->
                <b-col md="6">
                  <b-form-group
                    label="Chinese Death Date"
                    label-for="h-exercisedChineseDod"
                    class="mb-20"
                  >
                    <div class="d-flex align-items-center gap-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Year of Death"
                        vid="h-exercisedChineseDodYear"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="年"
                        >
                          <b-form-input
                            id="h-exercisedChineseDodYear"
                            v-model="exercisedChineseDodYear"
                            type="text"
                            placeholder="Year"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Month of Death"
                        vid="h-exercisedChineseDodMonth"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="月"
                        >
                          <b-form-input
                            id="h-exercisedChineseDodMonth"
                            v-model="exercisedChineseDodMonth"
                            type="text"
                            placeholder="Month"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        name="Chinese Day of Death"
                        vid="h-exercisedChineseDodDay"
                        rules=""
                      >
                        <b-input-group
                          class="input-group-merge text-mb-0"
                          append="日"
                        >
                          <b-form-input
                            id="h-exercisedChineseDodDay"
                            v-model="exercisedChineseDodDay"
                            type="text"
                            placeholder="Day"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title="Extended Information"
            >
              <b-alert
                v-if="isFieldsDisabled"
                variant="warning"
                show
                class=""
              >
                <div class="alert-body has-radius">
                  <span class="d-flex align-items-center">
                    <feather-icon
                      size="20"
                      icon="AlertCircleIcon"
                      class="mr-25"
                      style="top: 0;"
                    /> <div class="alert_text weight-400">Sex, Marital Status and Nationality will be saved to this person’s Customer profile.</div>
                  </span>
                </div>
              </b-alert>
              <b-row>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Sex"
                    vid="exercisedSex"
                    rules=""
                  >
                    <b-form-group
                      label="Sex"
                      label-for="h-exercisedSex"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedSex"
                        v-model="exercisedSex"
                        :options="genderOptions"
                        label="title"
                        :clearable="false"
                        :reduce="title => title.code"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Religion"
                    vid="exercisedReligion"
                    rules=""
                  >
                    <b-form-group
                      label="Religion"
                      label-for="h-exercisedReligion"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedReligion"
                        v-model="exercisedReligion"
                        :options="religionOptions"
                        label="text"
                        :clearable="false"
                        :reduce="title => title.value"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col> -->
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Marital Status"
                    vid="exercisedMaritalStatus"
                    rules=""
                  >
                    <b-form-group
                      label="Marital Status"
                      label-for="h-exercisedMaritalStatus"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedMaritalStatus"
                        v-model="exercisedMaritalStatus"
                        :options="maritalOptions"
                        label="title"
                        :clearable="false"
                        :reduce="title => title.code"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Nationality"
                    vid="exercisedNationality"
                    rules=""
                  >
                    <b-form-group
                      label="Nationality"
                      label-for="h-exercisedNationality"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-exercisedNationality"
                        v-model="exercisedNationality"
                        label="title"
                        :options="nationalityOptions"
                        :reduce="title => title.code"
                        :clearable="false"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Cremation Cert"
                    label-for="h-exercisedCremationCertificate"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Cremation Cert"
                      vid="h-exercisedCremationCertificate"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedCremationCertificate"
                        v-model="exercisedCremationCertificate"
                        placeholder="Cremation Cert"
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Reference No."
                    label-for="h-exercisedReferenceNo"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Reference No."
                      vid="h-exercisedReferenceNo"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedReferenceNo"
                        v-model="exercisedReferenceNo"
                        placeholder="Reference No."
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Funeral Address 1"
                    label-for="h-exercisedAddress1"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Funeral Address 1"
                      vid="h-exercisedAddress1"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedAddress1"
                        v-model="exercisedAddress1"
                        placeholder="Funeral Address 1"
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Funeral Address 2"
                    label-for="h-exercisedAddress2"
                    class="mb-20"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Funeral Address 2"
                      vid="h-exercisedAddress2"
                      rules=""
                    >
                      <b-form-input
                        id="h-exercisedAddress2"
                        v-model="exercisedAddress2"
                        placeholder="Funeral Address 2"
                        class="text-uppercase"
                        :state="(errors.length > 0) ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    name="Bury Created By"
                    vid="buryCreatedBy"
                    rules=""
                  >
                    <b-form-group
                      label="Bury Created By"
                      label-for="h-buryCreatedBy"
                      :state="(errors.length > 0) ? false : null"
                    >
                      <v-select
                        id="h-buryCreatedBy"
                        v-model="buryCreatedBy"
                        :options="createdByOptions"
                        label="title"
                        :clearable="false"
                        :reduce="title => title.code"
                        placeholder="Select from list"
                        class="text-uppercase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Bury Created On"
                    label-for="h-buryCreatedAt"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Bury Created On"
                      vid="buryCreatedAt"
                      rules=""
                    >
                      <b-input-group>
                        <flat-pickr
                          id="h-buryCreatedAt"
                          v-model="buryCreatedAt"
                          class="form-control flat-pickr-group"
                          placeholder="Bury Created On"
                          :config="flatPickrConfig"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CalendarIcon"
                            class="cursor-pointer"
                            data-toggle
                            size="18"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col> -->
              </b-row>
            </b-tab>
          </b-tabs>
        </validation-observer>
      </b-form>
      <div
        v-if="fileDetail.deceased && !fileDetail.deceased.length"
        class="mt-1 text-center px-3"
      >
        <small class="text-muted"><strong>Note:</strong> This is the first Exercised For person being added to the file. If you proceed, the system will automatically update this file’s exercise status to ‘Exercised’.</small>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="link"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          v-if="exercisedForEditID"
          variant="success"
          @click="ok()"
        >
          <span class="align-middle">Edit Exercised For Person</span>
        </b-button>
        <b-button
          v-else
          variant="success"
          class="custom-icon"
          @click="ok()"
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Add Exercised For Person</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BCardText, BRow, BButton, BCol, BTableSimple, BTbody, BTr, BTh, BTd, VBToggle, VBTooltip, BCollapse, BTab, BTabs, BCardBody, BAvatar,
  BDropdown, BDropdownItem, BImg, BFormTextarea, BLink, BForm, BFormGroup, BFormInput, BAlert, BMedia, BMediaAside, BMediaBody,
  BCardTitle, BInputGroup, BInputGroupAppend, BListGroup, BListGroupItem, BFormRadioGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store/index'
// import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import Ripple from 'vue-ripple-directive'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'
import FileInfo from './FileInfo.vue'
import RelatedFilesList from './RelatedFilesList.vue'
import RelatedServiceRequests from './RelatedServiceRequests.vue'
import RelatedInventoryRequests from './RelatedInventoryRequests.vue'
import RelatedInvoices from './RelatedInvoices.vue'
import ReceiptList from './ReceiptList.vue'
import BillingList from './BillingList.vue'
import AllocationList from './AllocationList.vue'
import InstallmentSchedule from './InstallmentSchedule.vue'
import RelatedEntitlements from './RelatedEntitlements.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BButton,
    BCol,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BCollapse,
    BTab,
    BTabs,
    BCardBody,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BImg,
    BFormTextarea,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BAlert,
    BMedia,
    BMediaAside,
    BMediaBody,
    BCardTitle,
    BInputGroup,
    BInputGroupAppend,
    BListGroup,
    BListGroupItem,
    BFormRadioGroup,

    vSelect,
    flatPickr,
    // Cleave,

    FileInfo,
    RelatedFilesList,
    RelatedServiceRequests,
    RelatedInventoryRequests,
    RelatedInvoices,
    ReceiptList,
    BillingList,
    AllocationList,
    InstallmentSchedule,
    RelatedEntitlements,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  data() {
    return {
      canViewThisAction,
      user: store.state.auth.userData,
      fileDetail: {},
      receipts: [],
      invoices: [],
      // fileDetail: JSON.parse(localStorage.getItem('customerFileDetail')),
      // receipts: JSON.parse(localStorage.getItem('customerFileDetailReceipts')),
      // invoices: JSON.parse(localStorage.getItem('customerFileDetailInvoices')),
      fileDetailID: '',
      fileDetailActivityLogs: [],
      fileAttachments: [],
      required,
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/frontend/logo-nirvana-memorial-garden.86fe2ff5.svg'),
      currentTabTitle: 'File Details',
      activeTab: 0,
      attachments: [],
      description: '',
      attachmentKey: '',
      iuIndexID: '',
      iuID: '',
      iuType: '',
      formattedIUType: '',
      iuIndex: '',
      iuTypeOnly: '',
      iuName: '',
      iuNRIC: '',
      iuDOB: '',
      iuRelationship: '',
      iuContact: '+65 ',
      iuAdd1: '',
      iuAdd2: '',
      iuAdd3: '',
      iuCountry: '',
      iuPostCode: '',
      fileRemarks: '',
      fileTransferDate: '',
      transferableUntil: '',
      exercisedTransferable: 'no',
      exercisedTransferableOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
      customerNameVal: '',
      customerEmailVal: '',
      statementMessage: '',
      exercisedModalTitle: 'Add Exercised For Person',
      intendedUser: '',
      exerciseDate: '',
      exercisedName: '',
      exercisedChineseName: '',
      exercisedNric: '',
      exercisedRelationship: '',
      exercisedDob: '',
      exercisedChineseDobDay: '',
      exercisedChineseDobMonth: '',
      exercisedChineseDobYear: '',
      exercisedDod: '',
      exercisedChineseDodDay: '',
      exercisedChineseDodMonth: '',
      exercisedChineseDodYear: '',
      exercisedSex: '',
      exercisedReligion: '',
      exercisedMaritalStatus: '',
      exercisedNationality: '',
      exercisedCremationCertificate: '',
      exercisedReferenceNo: '',
      exercisedAddress1: '',
      exercisedAddress2: '',
      buryCreatedBy: '',
      buryCreatedAt: '',
      exercisedForEditID: '',
      exercisedCustomer: '',
      exercisedEntity: '',
      buryID: '',
      updatedDate: '',
      nricQuery: '',
      exerciseEditMode: false,
      isIntendedDisabled: false,
      isFieldsDisabled: false,
      showCustomerCrossIcon: false,
      showCustomerSearchResult: false,
      searchCustomerResultNotFound: false,
      foundCustomers: [],
      timeout: null,
      flatPickrConfig: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', static: true, disableMobile: true,
      },
      genderOptions: [
        { title: 'MALE', code: 'MALE' },
        { title: 'FEMALE', code: 'FEMALE' },
        { title: 'N/A', code: 'N/A' },
      ],
      religionOptions: [
        { text: 'Buddhist', value: 'Buddhist' },
        { text: 'Taoist', value: 'Taoist' },
        { text: 'Christian', value: 'Christian' },
        { text: 'Soka', value: 'Soka' },
        { text: 'Catholic', value: 'Catholic' },
        { text: 'Free thinker', value: 'Free thinker' },
        { text: 'Others', value: 'Others' },
      ],
      relationshipOptions: [
        'Brother', 'Brother in-law', 'Cousin', 'Daughter', 'Daughter in-law', 'Elder Brother', 'Father', 'Father in-law',
        'Friend', 'God-father', 'Grand Daughter', 'Grandfather', 'Grandmother', 'Grandson', 'Great Grand Father',
        'Great Grand Mother', 'Husband', 'Mother', 'Mother in-law', 'N/A', 'Nephew', 'Niece', 'Relative', 'Self', 'Sister',
        'Sister in-law', 'Son', 'Son in-law', 'Uncle', 'Wife',
      ],
      maritalOptions: [
        { title: 'DIVORCED', code: 'DIVORCED' },
        { title: 'MARRIED', code: 'MARRIED' },
        { title: 'OTHERS', code: 'OTHERS' },
        { title: 'SINGLE', code: 'SINGLE' },
      ],
      createdByOptions: [],
      countryOptions: ['SINGAPORE', 'MALAYSIA', 'OTHERS'],
      nationalityOptions: [
        { title: 'SINGAPOREAN', code: 'SINGAPOREAN' },
        { title: 'MALAYSIAN', code: 'MALAYSIAN' },
        { title: 'OTHERS', code: 'OTHERS' },
      ],
      editModalTitle: 'Edit Intended User',
      iuContactValidation: false,
      iuContactError: 'The Mobile No. field is required',
      options: {
        prefix: {
          // numericOnly: true,
          // prefix: '+65',
          // blocks: [3, 8],
        },
      },
      tabIndex: 0,
      tabIndexCredit: 0,
      hasEmailAddress: '',
      entitlements: [],
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.fetchFileDetail()
      },
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fetchFileDetail()
    // document.title = `${this.fileDetail.fileNo} - ${this.fileDetail.nvsFileType} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
    // store.commit('breadcrumb/REMOVE_BREADCRUMB')
    // const newMeta = {
    //   active: true,
    //   text: `${this.fileDetail.fileNo} - ${this.fileDetail.nvsFileType}`,
    // }
    // store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
    // this.fileDetailActivityLogs = this.fileDetail.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
  },
  methods: {
    getCreatedBy() {
      if (this.fileDetail.createdByNvs) {
        return this.fileDetail.createdByNvs.name
      }
      if (this.fileDetail.createdBy) {
        return this.fileDetail.createdBy
      }

      return ''
    },
    getCreatedAt() {
      if (this.fileDetail.createdAtNvs) {
        return this.dateFormatWithTime(this.fileDetail.createdAtNvs)
      }
      if (this.fileDetail.createdAt) {
        return this.dateFormatWithFormatNTZ(this.fileDetail.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getUpdatedAt() {
      if (this.fileDetail.updatedAtNvs) {
        return this.dateFormatWithTime(this.fileDetail.updatedAtNvs)
      }
      if (this.fileDetail.updatedAt) {
        return this.dateFormatWithFormatNTZ(this.fileDetail.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },

    fetchFileDetail() {
      this.$http.get(`customer/files/${this.$route.params.id}/show`)
        .then(response => {
          if (this.$route.query && this.$route.query.tab === 'payment') {
            this.tabIndex = 1
          }
          if (this.$route.query && this.$route.query.ledger === 'receipt') {
            this.tabIndexCredit = 1
          }
          if (response.data.file.fileID) {
            this.fileDetail = response.data.file || {}
            this.invoices = response.data.invoices || []
            this.receipts = response.data.receipts || []
            this.entitlements = response.data.entitlements
            document.title = `File - ${this.fileDetail.fileNo} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
            // localStorage.setItem('customerFileDetail', JSON.stringify(this.fileDetail))
            // localStorage.setItem('customerFileDetailReceipts', JSON.stringify(response.data.receipts))
            // localStorage.setItem('customerFileDetailInvoices', JSON.stringify(response.data.invoices))
            store.commit('breadcrumb/REMOVE_BREADCRUMB')
            const newMeta = {
              active: true,
              text: `${this.fileDetail.fileNo} - ${this.fileDetail.nvsFileType}`,
            }
            store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
            this.fileDetailActivityLogs = this.fileDetail.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.fileAttachments = this.fileDetail.attachments.filter(file => file.fileStorage)
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    changeTab(index, tabName) {
      this.activeTab = index
      this.currentTabTitle = tabName
    },
    openEmailStatementModal() {
      this.customerNameVal = this.fileDetail.purchasers.length > 0 ? this.fileDetail.purchasers[0].name : ''
      this.customerEmailVal = this.fileDetail.purchasers.length > 0 ? this.fileDetail.purchasers[0].email : ''
      this.hasEmailAddress = this.fileDetail.purchasers.length > 0 ? this.fileDetail.purchasers[0].email : ''
      this.statementMessage = `Here is the Statement of Account for your purchase with us for ${this.fileDetail.nvsFileType} (file no.: ${this.fileDetail.fileNo}), as at ${moment().format('DD MMM YYYY')}. The statement provides a detailed summary of your transactions and current account balance.

Please be informed that the PDF is password-protected using your mobile number (e.g. 912345678).`
      this.$root.$emit('bv::show::modal', 'email-statement-modal-detail-page', '')
    },
    closeStatementModal() {
      this.$root.$emit('bv::hide::modal', 'email-statement-modal-detail-page', '')
    },
    sendEmailStatement() {
      let contact = this.customerEmailVal
      if (this.fileDetail.purchasers && this.fileDetail.purchasers.length && this.fileDetail.purchasers[0].contact) {
        contact = this.fileDetail.purchasers[0].contact.slice(-8)
      }
      const formData = new FormData()
      formData.append('customerName', this.customerNameVal)
      formData.append('customerEmail', this.customerEmailVal)
      formData.append('message', this.statementMessage)
      formData.append('fileType', this.fileDetail.nvsFileType)
      formData.append('fileNo', this.fileDetail.fileNo)
      formData.append('contact', contact)
      formData.append('fileID', this.$route.params.id)
      formData.append('url', `${window.location.origin}`)

      this.$http.post('customer/files/send/soa/statement', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.fileDetailActivityLogs = response.data.nvsFile.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Statement of Account Email Sent',
                text: response.data.message,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    resolveFileStatusVariant(status) {
      if (status === 'OPEN') return 'warning'
      if (status === 'BOOK') return 'info'
      return 'success'
    },
    getAgentImage(agents) {
      if (agents && agents.length) {
        const serviceAgent = agents.find(o => o.type === 'Sales & Service Agent' || o.type === 'Service Agent')
        if (serviceAgent && serviceAgent.image) return serviceAgent.image
      }

      return this.defaultImage
    },
    getAgentName(agents) {
      if (agents && agents.length) {
        const serviceAgent = agents.find(o => o.type === 'Sales & Service Agent' || o.type === 'Service Agent')
        if (serviceAgent && serviceAgent.name) return serviceAgent.name
      }

      return ''
    },
    resolvePaymentStatusVariant(status) {
      if (status === 'Fully Paid') return 'success'
      if (status === 'Ongoing Installment') return 'info'
      if (status === 'Pending Payment') return 'warning'
      if (status === 'Reactivation Fee') return 'danger'
      return 'secondary'
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    removeAttachment(name, id) {
      this.$http
        .post('customer/files/attachment/remove', { id, name, fileID: this.fileDetail._id })
        .then(response => {
          this.fileAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.fileDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    setAttachment(e) {
      if (e.target.files.length) {
        // const reader = new FileReader()
        // reader.readAsDataURL(this.file)
        // reader.onload = () => {
        //   e.target.filesrc = reader.result
        // }
        const acceptedTypes = ['image/jpeg', 'image/png', 'application/pdf']
        e.target.files.forEach(element => {
          if (acceptedTypes.includes(element.type)) {
            if (element.size > 20 * 1024 * 1024) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Can't add files more than 20mb",
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            } else {
              // const reader = new FileReader()
              // reader.readAsDataURL(element)

              // reader.onload = event => {
              //   const fileObj = {}
              //   fileObj.name = element.name
              //   fileObj.data = event.target.result
              //   fileObj.size = (element.size / (1024 * 1024)).toFixed(2)
              //   fileObj.type = element.type
              //   this.attachments.push(fileObj)
              // }
              const fileObj = {}
              fileObj.name = element.name
              fileObj.data = element
              fileObj.size = (element.size / (1024 * 1024)).toFixed(2)
              fileObj.type = element.type
              fileObj.description = ''
              fileObj.storage = 'local'
              this.attachments.push(fileObj)
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unsupported file type',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
      }
    },
    async uploadFile() {
      store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.attachments.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.uploadFileToAws(this.attachments[i].data)
        const { fileUrl, fileName, upload } = res
        const formData = new FormData()
        if (upload && fileUrl) {
          this.attachments[i].data = fileName
          this.attachments[i].storage = 'aws'
          formData.append('sAttachments', JSON.stringify([this.attachments[i]]))
        } else {
          formData.append('attachments', this.attachments[i].data)
        }

        formData.append('shouldUpload', (upload && fileUrl))
        formData.append('fileID', this.$route.params.id)
        formData.append('fileNo', this.fileDetail.fileNo)
        formData.append('nvsFileID', this.fileDetail._id)

        if (i === this.attachments.length - 1) {
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)
        }

        this.$http.post('customer/files/attachment/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            this.fileAttachments = response.data.data.attachments.filter(file => file.fileStorage)
            this.fileDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      this.attachments = []
    },
    // async uploadFile() {
    //   const res = await this.putFile()
    //   const { shouldUpload, fileAttachments } = res
    //   const formData = new FormData()
    //   // formData.append('attachments', JSON.stringify(fileAttachments))
    //   if (!shouldUpload) {
    //     fileAttachments.forEach(fileObj => {
    //       formData.append('attachments', fileObj.data)
    //     })
    //   } else {
    //     formData.append('sAttachments', JSON.stringify(fileAttachments))
    //   }
    //   formData.append('shouldUpload', shouldUpload)
    //   formData.append('fileID', this.$route.params.id)
    //   formData.append('fileNo', this.fileDetail.fileNo)
    //   formData.append('nvsFileID', this.fileDetail._id)

    //   this.$http.post('customer/files/attachment/upload', formData, {
    //     headers: { 'Content-Type': 'multipart/form-data' },
    //   })
    //     .then(response => {
    //       this.attachments = []
    //       this.fileDetail.attachments = response.data.data.attachments
    //       this.fileDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: response.data.message || '',
    //           icon: 'AlertTriangleIcon',
    //           variant: 'success',
    //         },
    //       })
    //     })
    //     .catch(error => {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: error.data.message || '',
    //           icon: 'AlertTriangleIcon',
    //           variant: 'danger',
    //         },
    //       })
    //     })
    // },
    async putFile() {
      let shouldUpload = true
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.attachments.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.uploadFileToAws(this.attachments[i].data)
        shouldUpload = res.upload
        if (i === 0) {
          if (!shouldUpload) {
            break
          }
        }

        this.attachments[i].data = res.fileName
        this.attachments[i].storage = 'aws'
      }

      return { fileAttachments: this.attachments, shouldUpload }
    },
    closeDescriptionModal() {
      this.$root.$emit('bv::hide::modal', 'modal-attachment-description', '')
    },
    updateDescription(key) {
      this.attachmentKey = key
      this.description = this.fileAttachments[key].description
      this.$root.$emit('bv::show::modal', 'modal-attachment-description', '')
    },
    fileRemarksEdit() {
      this.fileRemarks = this.fileDetail.remarks
      this.$root.$emit('bv::show::modal', 'modal-file-remarks', '')
    },
    fileTransferDateEdit() {
      this.fileTransferDate = this.fileDetail.fileTransferDate
      this.$root.$emit('bv::show::modal', 'modal-file-transfer-date', '')
    },
    allowFileTransfer() {
      this.transferableUntil = this.fileDetail.transferableUntil
      this.$root.$emit('bv::show::modal', 'modal-file-transfer-date-override', '')
    },
    allowExercisedFileTransfer() {
      this.exercisedTransferable = this.fileDetail.exercisedTransferable ? 'yes' : 'no'
      this.$root.$emit('bv::show::modal', 'modal-exercised-file-transfer-override', '')
    },
    saveFileRemarks() {
      this.$http
        .post('customer/files/save/file-remarks', {
          remarks: this.fileRemarks,
          oldRemarks: this.fileDetail.remarks,
          fileID: this.$route.params.id,
          nvsFileID: this.fileDetail._id,
          fileNo: this.fileDetail.fileNo,
        })
        .then(response => {
          if (response.data.success) {
            this.fileDetail.remarks = this.fileRemarks
            this.fileDetailActivityLogs = response.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.closeFileRemarksModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          } else {
            this.closeFileRemarksModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeFileRemarksModal() {
      this.$root.$emit('bv::hide::modal', 'modal-file-remarks', '')
    },
    saveFileTransferDate() {
      this.$http
        .post('customer/files/save/file-transfer-date', {
          date: this.fileTransferDate,
          oldDate: this.fileDetail.fileTransferDate ? this.dateFormat(this.fileDetail.fileTransferDate) : '',
          fileID: this.$route.params.id,
          nvsFileID: this.fileDetail._id,
          fileNo: this.fileDetail.fileNo,
        })
        .then(response => {
          if (response.data.success) {
            this.fileDetail.fileTransferDate = response.data.fileTransferDate
            this.fileDetailActivityLogs = response.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.closeFileTransferDateModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          } else {
            this.closeFileTransferDateModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeFileTransferDateModal() {
      this.$root.$emit('bv::hide::modal', 'modal-file-transfer-date', '')
    },
    saveOverrideFileTransferDate() {
      this.$http
        .post('customer/files/save/override-file-transferable-date', {
          date: this.transferableUntil,
          oldDate: this.fileDetail.transferableUntil ? this.dateFormat(this.fileDetail.transferableUntil) : '',
          fileID: this.$route.params.id,
          nvsFileID: this.fileDetail._id,
          fileNo: this.fileDetail.fileNo,
        })
        .then(response => {
          if (response.data.success) {
            this.fileDetail.transferableUntil = response.data.transferableUntil
            this.fileDetailActivityLogs = response.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.closeTransferOverrideDateModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          } else {
            this.closeTransferOverrideDateModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeTransferOverrideDateModal() {
      this.$root.$emit('bv::hide::modal', 'modal-file-transfer-date-override', '')
    },
    saveOverrideExercisedFileTransfer() {
      console.log(this.exercisedTransferable)
      this.$http
        .post('customer/files/save/override-exercised-file-transferable', {
          newValue: this.exercisedTransferable,
          oldValue: this.fileDetail.exercisedTransferable ? 'Yes' : 'No',
          fileID: this.$route.params.id,
          nvsFileID: this.fileDetail._id,
          fileNo: this.fileDetail.fileNo,
        })
        .then(response => {
          if (response.data.success) {
            this.fileDetail.exercisedTransferable = response.data.exercisedTransferable
            this.fileDetailActivityLogs = response.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.closeExercisedFileTransferOverrideModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          } else {
            this.closeExercisedFileTransferOverrideModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeExercisedFileTransferOverrideModal() {
      this.$root.$emit('bv::hide::modal', 'modal-exercised-file-transfer-override', '')
    },
    saveDescription() {
      const id = this.fileAttachments[this.attachmentKey]._id
      this.$http
        .post('customer/files/attachment/save-description', { id, description: this.description, fileID: this.fileDetail._id })
        .then(response => {
          this.fileAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.closeDescriptionModal()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    async intendedUserEdit(user, index) {
      this.iuIndexID = user._id
      this.iuIndex = index
      this.iuType = user.type
      this.iuID = user.entityID
      let type = ''
      const number = user.type.split('_').pop()
      // this.iuNRIC = user.encryptedNric
      this.iuNRIC = user.nric
      if (user.type.includes('INTENDED_USER')) {
        type = 'Intended User'
      } else if (user.type.includes('NEXT OF KIN')) {
        type = 'Next Of Kin'
        // this.iuNRIC = user.nric
      } else {
        type = 'Addressee'
      }
      this.iuTypeOnly = type
      this.formattedIUType = `${type} ${number}`
      this.$refs.update_intended_user_modal.show()
      await this.$nextTick()
      this.iuName = user.name
      this.iuDOB = user.dob ? moment(user.dob).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')
      this.iuRelationship = user.relation
      this.iuContact = user.contact || '+65 '
      // this.iuContact = '+6512345678'
      this.iuAdd1 = user.perAddress1 ? user.perAddress1 : ''
      this.iuAdd2 = user.perAddress2 ? user.perAddress2 : ''
      this.iuAdd3 = user.perAddress3 ? user.perAddress3 : ''
      this.iuPostCode = user.perPostcode ? user.perPostcode : ''
      this.iuCountry = user.perCountry ? user.perCountry : ''
      this.editModalTitle = `Edit ${type} #${number}`
    },
    intendedUserRemove(user, index) {
      let type = ''
      let iyType = ''
      if (user.type.includes('INTENDED_USER')) {
        type = 'an intended user'
        iyType = 'Intended User'
      } else if (user.type.includes('NEXT OF KIN')) {
        type = 'a next of kin'
        iyType = 'Next Of Kin'
      } else {
        type = 'an addressee'
        iyType = 'Addressee'
      }
      this.$swal({
        title: `Remove ${user.name}`,
        html: `${user.name} will no longer be registered as ${type} for this file. `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/delete.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, Remove',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            let parentEntity = ''
            if (this.fileDetail && this.fileDetail.purchasers && this.fileDetail.purchasers.length) {
              parentEntity = this.fileDetail.purchasers[0].entityID
            }
            formData.append('parentEntity', parentEntity)
            formData.append('fileID', this.fileDetail.fileID)
            formData.append('iuIndexID', user._id)
            formData.append('nvsFileID', this.fileDetail._id)
            formData.append('entityID', user.entityID)
            formData.append('type', user.type)

            this.$http.post(`customer/files/${this.$route.params.id}/delete/intended-user`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(response => {
                if (response.data.success) {
                  if (iyType === 'Intended User') {
                    this.fileDetail.intendedUsers.splice(index, 1)
                  } else if (iyType === 'Next Of Kin') {
                    this.fileDetail.nextOfKins.splice(index, 1)
                  } else {
                    this.fileDetail.addressees.splice(index, 1)
                  }
                  this.$swal({
                    title: 'Nominee Deleted!',
                    html: `<strong>${user.name}</strong> has been removed`,
                    // eslint-disable-next-line global-require
                    imageUrl: require('@/assets/images/icons/save.png'),
                    imageWidth: 80,
                    imageHeight: 80,
                    imageAlt: 'Custom Icon',
                    showCancelButton: false,
                    confirmButtonText: 'Okay',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                }
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    intendedUserSubmitForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.intendedUserEditForm.validate().then(success => {
        const validContact = true
        // if (this.iuContact.length === 12) {
        //   this.iuContactValidation = false
        //   validContact = true
        // } else {
        //   this.iuContactValidation = true
        // }
        if (success && validContact) {
          this.$swal({
            title: 'Save current changes?',
            html: 'Your changes will overwrite the current information, are you sure?',
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/warning.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: 'Yes, Save Changes',
            cancelButtonText: 'No, Go Back',
            customClass: {
              confirmButton: 'btn btn-primary ml-1',
              cancelButton: 'btn btn-outline-primary',
            },
            buttonsStyling: false,
          })
            .then(result => {
              if (result.value) {
                const formData = new FormData()
                let parentEntity = ''
                if (this.fileDetail && this.fileDetail.purchasers && this.fileDetail.purchasers.length) {
                  parentEntity = this.fileDetail.purchasers[0].entityID
                }
                let day = '0'
                let month = '0'
                let year = '0000'
                if (this.iuDOB) {
                  day = moment(this.iuDOB, 'DD/MM/YYYY').format('D')
                  month = moment(this.iuDOB, 'DD/MM/YYYY').format('M')
                  year = moment(this.iuDOB, 'DD/MM/YYYY').format('YYYY')
                }
                formData.append('parentEntity', parentEntity)
                formData.append('fileID', this.fileDetail.fileID)
                formData.append('entityID', this.iuID)
                formData.append('type', this.iuType)
                formData.append('name', this.iuName)
                formData.append('nric', this.iuNRIC)
                formData.append('dob', moment(this.iuDOB, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                formData.append('relation', this.iuRelationship)
                formData.append('phone', this.iuContact)
                formData.append('add1', this.iuAdd1)
                formData.append('add2', this.iuAdd2)
                formData.append('add3', this.iuAdd3)
                formData.append('postCode', this.iuPostCode)
                formData.append('country', this.iuCountry)
                formData.append('day', day)
                formData.append('month', month)
                formData.append('year', year)
                formData.append('iuIndexID', this.iuIndexID)
                formData.append('nvsFileID', this.fileDetail._id)

                this.$http.post(`customer/files/${this.$route.params.id}/edit/intended-user`, formData, {
                  headers: { 'Content-Type': 'multipart/form-data' },
                })
                  .then(response => {
                    if (response.data.success) {
                      // this.fileDetail.intendedUsers = response.data.fileDetail.intendedUsers
                      // this.fileDetail.nextOfKins = response.data.fileDetail.nextOfKins
                      // this.fileDetail.addressees = response.data.fileDetail.addressees
                      this.$set(this.fileDetail, 'intendedUsers', response.data.fileDetail.intendedUsers)
                      this.$set(this.fileDetail, 'nextOfKins', response.data.fileDetail.nextOfKins)
                      this.$set(this.fileDetail, 'addressees', response.data.fileDetail.addressees)
                      // if (this.iuTypeOnly === 'Intended User') {
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'relation', this.iuRelationship)
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'contact', this.iuContact)
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'Per_Addr1', this.iuAdd1)
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'Per_Addr2', this.iuAdd2)
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'Per_Addr3', this.iuAdd3)
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'Per_Postcode', this.iuPostCode)
                      //   this.$set(this.fileDetail.intendedUsers[this.iuIndex], 'Per_Country', this.iuCountry)
                      // } else if (this.iuTypeOnly === 'Next Of Kin') {
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Relation', this.iuRelationship)
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Per_Tel_No_Hp', this.iuContact)
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Per_Addr1', this.iuAdd1)
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Per_Addr2', this.iuAdd2)
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Per_Addr3', this.iuAdd3)
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Per_Postcode', this.iuPostCode)
                      //   this.$set(this.fileDetail.nextOfKins[this.iuIndex], 'Per_Country', this.iuCountry)
                      // }
                      this.$refs.update_intended_user_modal.hide()
                      this.$swal({
                        title: 'Nominee Updated!',
                        html: `<strong>${this.formattedIUType}</strong> has been updated`,
                        // eslint-disable-next-line global-require
                        imageUrl: require('@/assets/images/icons/save.png'),
                        imageWidth: 80,
                        imageHeight: 80,
                        imageAlt: 'Custom Icon',
                        showCancelButton: false,
                        confirmButtonText: 'Okay',
                        customClass: {
                          confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                      })
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                          icon: 'AlertTriangleIcon',
                          variant: 'danger',
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                      },
                    })
                  })
              }
            })
        }
      })
    },
    allowedExercising(data) {
      this.$set(this.fileDetail, 'isAllowedExercising', true)
      this.$set(this.fileDetail, 'exercisingAllowedBy', data.exercisingAllowedBy)
    },
    disallowedExercising() {
      this.$set(this.fileDetail, 'isAllowedExercising', false)
      this.$set(this.fileDetail, 'exercisingAllowedBy', null)
    },
    isRecentlyConfirmed() {
      if (!this.fileDetail.confirmDate) return false
      const confirmDate = moment(this.fileDetail.confirmDate)
      return this.fileDetail.nvsFileType === 'Funeral Service Package' && confirmDate.isAfter(moment().subtract(30, 'days'))
    },
    fetchResults() {
      const query = this.nricQuery

      if (query && query.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$http.get('appointment/bookings/respond-with/customers', { params: { search: query } })
            .then(response => {
              if (response.data.customers.length === 0) {
                this.foundCustomers = []
                this.searchCustomerResultNotFound = true
                this.showCustomerSearchResult = false
              } else {
                this.foundCustomers = response.data.customers
                this.showCustomerSearchResult = true
                this.searchCustomerResultNotFound = false
              }
              this.exercisedCustomer = ''
              this.exercisedEntity = ''
              this.exercisedName = ''
              this.exercisedNric = ''
              this.exercisedRelationship = ''
              this.exercisedDob = ''
              this.exercisedSex = ''
              this.exercisedNationality = ''
              this.exercisedMaritalStatus = ''
              this.isFieldsDisabled = false
              this.isIntendedDisabled = false
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }, this.debounceMilliseconds)
      }
    },
    setCustomer(customer) {
      this.showCustomerCrossIcon = true
      this.nricQuery = customer.nric
      this.exercisedCustomer = customer ? customer._id : ''
      this.exercisedEntity = customer.entityID
      this.exercisedName = customer.name
      this.exercisedNric = customer.nric
      this.exercisedRelationship = ''
      this.exercisedDob = customer.dob
      this.exercisedSex = customer ? customer.sex : ''
      this.exercisedNationality = customer ? customer.nationality : ''
      this.exercisedMaritalStatus = customer ? customer.maritalStatus : ''
      this.intendedUser = ''
      this.isFieldsDisabled = true
      this.isIntendedDisabled = true
      if (customer) {
        this.$http.get(`customer/customers/${customer._id}`)
          .then(response => {
            if (response.data.success) {
              this.exercisedMaritalStatus = response.data.data.maritalStatus || ''
              this.exercisedChineseName = response.data.data.chineseName || ''
            }
          })
      }
    },
    resetCustomerSearchResult() {
      setTimeout(() => {
        this.searchCustomerResultNotFound = false
        this.showCustomerSearchResult = false
      }, 500)
    },
    clearCustomerSearchInput() {
      this.nricQuery = ''
      this.exercisedCustomer = ''
      this.exercisedEntity = ''
      this.exercisedName = ''
      this.exercisedNric = ''
      this.exercisedRelationship = ''
      this.exercisedDob = ''
      this.exercisedSex = ''
      this.exercisedNationality = ''
      this.exercisedMaritalStatus = ''
      this.showCustomerCrossIcon = false
      this.searchCustomerResultNotFound = false
      this.showCustomerSearchResult = false
      this.isFieldsDisabled = false
      this.isIntendedDisabled = false
    },
    openExercisedForAddModal() {
      this.isFieldsDisabled = false
      this.exerciseEditMode = false
      this.exercisedModalTitle = 'Add Exercised For Person'
      this.exercisedForEditID = ''
      let title = ''
      let message = ''
      if (this.fileDetail.nvsFileStatus !== 'CONFIRM/Exercise') {
        if (this.isRecentlyConfirmed()) {
          if (this.fileDetail.paymentStatus !== 'Fully Paid') {
            title = 'Unpaid & Newly Confirmed File'
            message = 'This file is newly confirmed and has not been fully paid. Please ensure all related details are reviewed within the 30-day window before proceeding.<br><br>You can still proceed to exercise the file, but note that an email will be sent to the Collections department to follow up on payment, and you may be involved in ensuring the file is paid.<br><br>Do you wish to proceed?'
          } else {
            title = 'The confirmation occurred less than 30 days ago!'
            message = 'This file is newly confirmed—please ensure all related details are reviewed within the 30-day window before you proceed. Do you wish to proceed?'
          }
        } else if (this.fileDetail.paymentStatus !== 'Fully Paid') {
          title = 'This file is in pending payment'
          message = 'This file has not been fully paid. You can still proceed to exercise the file. Note that an email will be sent to the collections department to help ensure this file is paid, and you may be involved in ensuring file payment as well.'
        }
      }
      if (title) {
        this.$swal({
          title,
          html: message,
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/warning.png'),
          imageWidth: 80,
          imageHeight: 80,
          imageAlt: 'Custom Icon',
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonText: 'Yes, I want to continue',
          cancelButtonText: 'No, cancel',
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
          width: 555,
        })
          .then(result => {
            if (result.value) {
              this.$root.$emit('bv::show::modal', 'modal-exercised-user', '')
            }
          })
      } else {
        this.$root.$emit('bv::show::modal', 'modal-exercised-user', '')
      }
    },
    openExercisedForEditModal(data) {
      this.isFieldsDisabled = true
      this.exerciseEditMode = true
      this.exercisedModalTitle = 'Edit Exercised For Person'
      this.exercisedCustomer = data.customer || ''
      this.exercisedEntity = data.entityID || ''
      this.buryID = data.buryID || ''
      this.updatedDate = data.updatedDate || ''
      this.exercisedForEditID = data._id || ''
      this.exerciseDate = data.exerciseDate ? moment(data.exerciseDate).format('DD/MM/YYYY') : ''
      this.intendedUser = data.intendedUser || ''
      // eslint-disable-next-line eqeqeq
      const iu = this.fileDetail.intendedUsers.find(o => o.entityID == data.entityID)
      if (iu) {
        this.intendedUser = data.entityID
      }
      this.exercisedName = data.name || ''
      this.exercisedChineseName = data.chineseName || ''
      this.exercisedNric = data.nric || ''
      this.nricQuery = data.nric || ''
      this.exercisedReligion = data.religion || ''
      this.exercisedMaritalStatus = data.maritalStatus || ''
      this.exercisedRelationship = data.relation || ''
      this.exercisedDob = data.dob ? moment(data.dob).format('DD/MM/YYYY') : ''
      this.exercisedChineseDobDay = data.chineseDobDay || ''
      this.exercisedChineseDobMonth = data.chineseDobMonth || ''
      this.exercisedChineseDobYear = data.chineseDobYear || ''
      this.exercisedSex = data.sex || ''
      this.exercisedNationality = data.nationality || ''
      this.exercisedDod = data.dod ? moment(data.dod).format('DD/MM/YYYY') : ''
      this.exercisedChineseDodDay = data.chineseDodDay || ''
      this.exercisedChineseDodMonth = data.chineseDodMonth || ''
      this.exercisedChineseDodYear = data.chineseDodYear || ''
      this.exercisedCremationCertificate = data.cremationCertificate || ''
      this.exercisedReferenceNo = data.referenceNo || ''
      this.exercisedAddress1 = data.address1 || ''
      this.exercisedAddress2 = data.address2 || ''
      this.buryCreatedBy = data.buryCreatedBy || ''
      this.buryCreatedAt = data.buryCreatedDate ? moment(data.buryCreatedDate).format('DD/MM/YYYY') : ''
      this.$root.$emit('bv::show::modal', 'modal-exercised-user', '')
    },
    showExercisedForRemoveWarning(data) {
      const title = `Remove ${data.name}?`
      let message = ''
      if (this.fileDetail.deceased.length === 1) {
        message = `${data.name} will no longer be registered as the Exercise For person for this file. Removing this person will also revert the file from Exercised status.<br><br>Are you sure you want to remove?`
      } else {
        message = `${data.name} will no longer be registered as the Exercise For person for this file.<br><br>Are you sure you want to remove?`
      }
      if (title) {
        this.$swal({
          title,
          html: message,
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/delete.png'),
          imageWidth: 80,
          imageHeight: 80,
          imageAlt: 'Custom Icon',
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonText: 'Yes, remove',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
          width: 408,
        })
          .then(result => {
            if (result.value) {
              const formData = new FormData()
              formData.append('name', data.name)
              formData.append('buryID', data.buryID)
              formData.append('entityID', data.entityID)
              formData.append('updatedAt', data.updatedDate)
              formData.append('exercisedForID', data._id)
              formData.append('nvsFileID', this.fileDetail._id)

              this.$http.post(`customer/files/${this.$route.params.id}/remove/exercised-for`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
              })
                .then(response => {
                  if (response.data.success) {
                    this.$set(this.fileDetail, 'deceased', response.data.fileDetail.deceased)
                    this.$set(this.fileDetail, 'nvsFileStatus', response.data.fileDetail.nvsFileStatus)
                    this.$toast({
                      component: ToastificationContentCustom,
                      props: {
                        title: 'Successfully removed',
                        text: `<strong>${data.name}</strong> has no longer be registered as a Exercised For Person for this file.`,
                        icon: 'Trash2Icon',
                        variant: 'danger',
                        hideClose: true,
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                      },
                    })
                  }
                })
                .catch(error => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                })
            }
          })
      }
    },
    getIntendedUserData() {
      const iu = this.fileDetail.intendedUsers.find(o => o.entityID === this.intendedUser)
      if (iu) {
        // eslint-disable-next-line prefer-destructuring
        const customer = iu.customer
        this.exercisedCustomer = customer ? customer._id : ''
        this.exercisedEntity = iu.entityID
        this.exercisedName = iu.name
        this.exercisedNric = iu.nric
        this.nricQuery = iu.nric
        this.exercisedRelationship = iu.relation
        this.exercisedDob = iu.dob
        this.exercisedSex = customer ? customer.sex : ''
        this.exercisedNationality = customer ? customer.nationality : ''
        this.exercisedMaritalStatus = customer ? customer.maritalStatus : ''
        this.isFieldsDisabled = true
        this.showCustomerCrossIcon = true
        if (customer) {
          this.$http.get(`customer/customers/${customer._id}`)
            .then(response => {
              if (response.data.success) {
                this.exercisedMaritalStatus = response.data.data.maritalStatus || ''
                this.exercisedChineseName = response.data.data.chineseName || ''
              }
            })
        }
      } else {
        this.nricQuery = ''
        this.exercisedCustomer = ''
        this.exercisedEntity = ''
        this.exercisedName = ''
        this.exercisedNric = ''
        this.exercisedRelationship = ''
        this.exercisedDob = ''
        this.exercisedSex = ''
        this.exercisedNationality = ''
        this.exercisedMaritalStatus = ''
        this.isFieldsDisabled = false
        this.showCustomerCrossIcon = false
      }
    },
    exercisedForSubmitForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.exercisedForm.validate().then(success => {
        if (success) {
          if (this.exercisedForEditID) {
            this.exercisedForEditForm()
          } else {
            this.exercisedForCreateForm()
          }
        }
      })
    },
    exercisedForCreateForm() {
      const formData = new FormData()
      formData.append('exerciseDate', this.exerciseDate ? moment(this.exerciseDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('customer', this.exercisedCustomer)
      formData.append('entityID', this.exercisedEntity)
      formData.append('intendedUser', this.intendedUser)
      formData.append('name', this.exercisedName)
      formData.append('chineseName', this.exercisedChineseName)
      formData.append('nric', this.exercisedNric ? this.exercisedNric : this.nricQuery)
      formData.append('sex', this.exercisedSex)
      formData.append('religion', this.exercisedReligion)
      formData.append('maritalStatus', this.exercisedMaritalStatus)
      formData.append('nationality', this.exercisedNationality)
      formData.append('dob', this.exercisedDob ? moment(this.exercisedDob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDobDay', this.exercisedChineseDobDay)
      formData.append('chineseDobMonth', this.exercisedChineseDobMonth)
      formData.append('chineseDobYear', this.exercisedChineseDobYear)
      formData.append('dod', this.exercisedDod ? moment(this.exercisedDod, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDodDay', this.exercisedChineseDodDay)
      formData.append('chineseDodMonth', this.exercisedChineseDodMonth)
      formData.append('chineseDodYear', this.exercisedChineseDodYear)
      formData.append('cremationCertificate', this.exercisedCremationCertificate)
      formData.append('referenceNo', this.exercisedReferenceNo)
      formData.append('relation', this.exercisedRelationship)
      formData.append('address1', this.exercisedAddress1)
      formData.append('address2', this.exercisedAddress2)
      formData.append('buryCreatedBy', this.buryCreatedBy)
      formData.append('buryCreatedDate', this.buryCreatedAt ? moment(this.buryCreatedAt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('nvsFileID', this.fileDetail._id)

      this.$http.post(`customer/files/${this.$route.params.id}/add/exercised-for`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$set(this.fileDetail, 'deceased', response.data.fileDetail.deceased)
            this.$set(this.fileDetail, 'nvsFileStatus', response.data.fileDetail.nvsFileStatus)
            this.$refs.exercised_for_modal.hide()
            let text = `<strong>${this.exercisedName}</strong> has been added as the Exercise For person, and the file status has been updated to Exercised.`
            if (response.data.fileDetail.deceased.length > 1) {
              text = `<strong>${this.exercisedName}</strong> has been added as the Exercise For person.`
            }
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Successfully added',
                text,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    exercisedForEditForm() {
      const formData = new FormData()
      formData.append('exerciseDate', this.exerciseDate ? moment(this.exerciseDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('customer', this.exercisedCustomer)
      formData.append('entityID', this.exercisedEntity)
      formData.append('buryID', this.buryID)
      formData.append('updatedAt', this.updatedDate)
      formData.append('intendedUser', this.intendedUser)
      formData.append('name', this.exercisedName)
      formData.append('chineseName', this.exercisedChineseName)
      formData.append('nric', this.exercisedNric ? this.exercisedNric : this.nricQuery)
      formData.append('sex', this.exercisedSex)
      formData.append('religion', this.exercisedReligion)
      formData.append('maritalStatus', this.exercisedMaritalStatus)
      formData.append('nationality', this.exercisedNationality)
      formData.append('dob', this.exercisedDob ? moment(this.exercisedDob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDobDay', this.exercisedChineseDobDay)
      formData.append('chineseDobMonth', this.exercisedChineseDobMonth)
      formData.append('chineseDobYear', this.exercisedChineseDobYear)
      formData.append('dod', this.exercisedDod ? moment(this.exercisedDod, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('chineseDodDay', this.exercisedChineseDodDay)
      formData.append('chineseDodMonth', this.exercisedChineseDodMonth)
      formData.append('chineseDodYear', this.exercisedChineseDodYear)
      formData.append('cremationCertificate', this.exercisedCremationCertificate)
      formData.append('referenceNo', this.exercisedReferenceNo)
      formData.append('relation', this.exercisedRelationship)
      formData.append('address1', this.exercisedAddress1)
      formData.append('address2', this.exercisedAddress2)
      formData.append('buryCreatedBy', this.buryCreatedBy)
      formData.append('buryCreatedDate', this.buryCreatedAt ? moment(this.buryCreatedAt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '')
      formData.append('nvsFileID', this.fileDetail._id)
      formData.append('editID', this.exercisedForEditID)

      this.$http.post(`customer/files/${this.$route.params.id}/edit/exercised-for`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$set(this.fileDetail, 'deceased', response.data.fileDetail.deceased)
            this.$refs.exercised_for_modal.hide()
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Successfully edited',
                text: `The Exercise For person <strong>${this.exercisedName}</strong> has been edited.`,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
  .timeline-variant-info .timeline-item-point {
    background-color: #00cfe8 !important;
  }
  .timeline-variant-purple .timeline-item-point {
    background-color: #7367F0 !important;
  }
  .tab-parent .nav-item {
    margin-bottom: 0.75rem !important;
  }
  .exercised-for-tab {
    .form-control:disabled, .form-control[readonly] {
      background-color: #F7F7F8;
    }
    .flatpickr-input:disabled {
      background-color: #F7F7F8 !important;
    }
    .vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__clear, .vs--disabled .vs__search, .vs--disabled .vs__selected, .vs--disabled .vs__open-indicator {
      cursor: not-allowed;
      background-color: #F7F7F8;
    }
  }

  .timeline-variant-info .timeline-item-point {
  background-color: #00cfe8 !important;
}
.timeline-variant-purple .timeline-item-point {
  background-color: #7367F0 !important;
}

.z-index-99{
  z-index: 99;
}
h3.result-search-header{
 font-family: Montserrat;
 font-size: 14px !important;
 font-weight: 600;
 line-height: 18px;
 text-align: left;
 color: #333333;
}
.card-body .input-group .input__append-border-right{
 border-right: 1px solid #D2DCEA !important;
}
.card-body .input-group .input__append-border-right:focus{
    border-color: #104D9D !important;
}
</style>

<style lang="scss">
  @import "~@core/scss/base/pages/app-email.scss";
</style>
